import { Button } from "react-bootstrap";
import Card from "react-bootstrap/Card";
import { useNavigate } from "react-router-dom";
import { Text, LanguageContext } from "../../../utils/Language";
import { useContext } from "react";


function openDetailPage(type, id, state, navigate) {
  if (type == "Plan") navigate("/action/" + id, state);
  if (type == "Kargo") navigate("/actionkargo/" + id, state);
}

function Action(props) {
  const actionTypeToColor = {
    Baskı: "light",
    Plan: "info",
    Kargo: "info",
  };
  
  const color = actionTypeToColor[props.Type];
  const navigate = useNavigate();
  const { dictionary } = useContext(LanguageContext);
  const actionId = props.actionId;
  const readonly = props.readonly;


  
  const actionTypeToButtonText = {
    Baskı: dictionary.actionDetails.PrintDetails,
    Plan: dictionary.actionDetails.PlanDetails,
    Kargo: dictionary.actionDetails.ImageDetails,
  };
  

  return (
    <Card
      className="my-1"
      bg={color}
      text={color === "light" ? "dark" : "white"}
    >
      <Card.Header>
        {props.SystemDate.split(" ")[0] + " - " + props.Type}
      </Card.Header>
      <Card.Body>
        <div className="d-flex justify-content-between">
          {props.Content}
          <Button
            align="end"
            variant="primary"
            className="w-10"
            onClick={() =>
              openDetailPage(
                props.Type,
                props.Id,
                { state: { actionId, readonly, ...(props.patientDetails) } },
                navigate
              )
            }
          >
            {actionTypeToButtonText[props.Type]}{" "}
          </Button>
        </div>
      </Card.Body>
    </Card>
  );
}

export default Action;
